export type QuickAccessPad = 'b' | 'g' | 'n' | 'p' | 'o'

export type QuickAccessIconKey =
  | 'library'
  | 'chat'
  | 'assignments'
  | 'exams'
  | 'resources'
  | 'classroom'

export interface QuickAccessEntry {
  id: string
  href: string
  icon: QuickAccessIconKey
  pad: QuickAccessPad
  title: string
  sub: string
}

export interface QuickAccessClassroom {
  id: string
  name: string
  studentCount: number
}

export const TEACHER_QUICK_ACCESS_DESTINATIONS: QuickAccessEntry[] = [
  { id: 'library',     href: '/teacher/library',     icon: 'library',     pad: 'b', title: 'Ma bibliothèque',     sub: 'Cours, exercices, évaluations' },
  { id: 'chat',        href: '/teacher/chat',        icon: 'chat',        pad: 'p', title: 'Assistant programme', sub: 'Confronter vos productions au BO' },
  { id: 'assignments', href: '/teacher/assignments', icon: 'assignments', pad: 'o', title: 'Mes devoirs',         sub: 'Suivi des devoirs envoyés' },
  { id: 'exams',       href: '/teacher/exams',       icon: 'exams',       pad: 'p', title: 'Examens sur table',   sub: 'Sessions et copies' },
  { id: 'resources',   href: '/mini-apps',           icon: 'resources',   pad: 'g', title: 'Ressources Naïa',     sub: 'Couverture du programme' },
]

export const TEACHER_QUICK_ACCESS_DEFAULT_PINS: string[] = ['library', 'chat', 'assignments', 'resources']

export function buildTeacherQuickAccess(classrooms: QuickAccessClassroom[]): QuickAccessEntry[] {
  return [
    ...TEACHER_QUICK_ACCESS_DESTINATIONS,
    ...classrooms.map((c) => ({
      id:    `class-${c.id}`,
      href:  `/teacher/classes/${c.id}`,
      icon:  'classroom' as const,
      pad:   'g' as const,
      title: c.name,
      sub:   c.studentCount > 0 ? `${c.studentCount} élèves` : 'Aucun élève inscrit',
    })),
  ]
}
